import { useEffect, type ReactNode } from "react";
import { applyTheme, defaultTheme, type ThemeTokens } from "./tokens";
import "./theme.css";

interface ThemeProviderProps {
  theme?: ThemeTokens;
  children: ReactNode;
}

/**
 * Applies theme tokens as CSS variables on <html>. Swap `theme` to re-skin
 * the entire app without touching any feature component.
 */
export function ThemeProvider({ theme = defaultTheme, children }: ThemeProviderProps) {
  useEffect(() => {
    applyTheme(theme, document.documentElement);
  }, [theme]);

  return <>{children}</>;
}
